<section class="header-wrapper">
    <div class="container d-hidden d-md-block py-2">
        <div class="row">
            <div class="align-items-center col col-md-5 d-flex flex-row gap-4 justify-content-start">
                <a href="https://bornprimitive.com/pages/tactical" class="nav-link">Shop Tactical</a>
            </div>
            <div class="col col-md-2 align-content-center col-md-2 justify-content-center d-flex">
                <a [routerLink]="'/'" class="nav-link">
                    <img class="logo" [src]="logo" alt="Born Primitive Tactical, TAA/BERRY Compliant Apparel"
                        style="max-height: 70px;">
                </a>
            </div>
            <div class="col align-items-center col-md-5 d-flex flex-row gap-4 justify-content-end">
                <a [routerLink]="['contact']" class="nav-link">CONTACT</a>
            </div>
        </div>
    </div>
</section>